export function parseBool(s) {
  return /true|yes|on|1/.test(s);
}
